import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Query = Api.Core.Claim.SavePublic.IQuery;
type Request = Api.Core.Claim.SavePublic.IRequest;
type Response = Api.Core.Claim.SavePublic.IResponse;
type Headers = Api.Core.Claim.SavePublic.IHeaders;
const url = '/api/Public/Claim';
export default async function claimSavePublic(props: { body: Request; query: Query }): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, null, props.query),
    body: props.body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
